<template>
  <div class="section is-dark" :style="'background-color:' + backgroundColor">
    <div class="container">
      <div class="columns is-vcentered">
        <div class="column">

          <slot name="left"></slot>
        </div>
        <div class="column ">
          <slot name="right"></slot>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['backgroundColor']
  }
</script>

<style scoped>
  .section.is-header {
    padding-top: 150px;
  }
</style>